import { render, staticRenderFns } from "./activitiesList.vue?vue&type=template&id=484c7622&scoped=true&"
import script from "./activitiesList.vue?vue&type=script&lang=js&"
export * from "./activitiesList.vue?vue&type=script&lang=js&"
import style0 from "./activitiesList.vue?vue&type=style&index=0&id=484c7622&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "484c7622",
  null
  
)

export default component.exports